import React, { Component } from 'react';
import { PnkConnect } from '../../../pnk-react/pnk-miniredux';
import AppUtils from '../../../apputils';
import axios from 'axios';
import EventForm from './form';
import $ from 'jquery';
import { GetOrganizersList } from "../../../models/users";
import { CreateEvents, UpdateEventDetails } from "../../../models/events";
import { GetCategoryData } from '../../../models/category';

var gapi = window.gapi;
var clientID = '833238440283-s64g3p22cvd7vfb00jmpv47i2kap8bvf.apps.googleusercontent.com';
var apiKey = 'AIzaSyCBydqFkMfCwgYuDm4nspbttp_hZwj5WaU';
var discovery_docs = ["https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"];
var scopes = "https://www.googleapis.com/auth/calendar.events";
const img_path = 'https://www.kinshipliving.com/images/uploads/kinship/events/';
//import DateTimePicker from 'react-datetime-picker';

class createEvent extends Component {

    constructor() {
        super()
        this.state = {
            showButtonType: "Create Session",
            txtEventName: '',
            ddlEventCategory: '',
            ddlEventLanguage: '',
            txtEventStartTime: '',
            txtEventDuration: '',
            fileEventImage: '',
            txtEventSeats: '',
            txtEventAlreadyFilled: '',
            ddlEventOrganizerName: '',
            ddlEventRecurring: '',
            ddlEventMode: '',
            txtEventDescription: '',
            ddlEventEntryMode: '',
            txtEventPricingINR: '',
            txtEventPricingUSD: '',
            ddlEventStatus: '',
            mode: 'add',
            actionType: 'save',
            showEditBtn: 'none',
            currentSeletedEventId: '',
            editData: false,
            sendData: false,
            getOrganizers: true,
            getCategory: true,
            createEvent: false,
            organizerlist: [],
            categorylist: []
        }
        this.editDataObj = {}
        this.data = {}
    }

    HandleEventInput = (e) => {
        //  alert(e.traget.value)
        if (document.getElementById('fileEventImage').value !== undefined && document.getElementById('fileEventImage').value !== '') {
            this.editDataObj['fileEventImage'] = document.getElementById('fileEventImage').value;
            this.setState({
                fileEventImage: document.getElementById('fileEventImage').value
            })
        }

        let val = e.target.value;
        let name = e.target.name;
        this.editDataObj[name] = val;
        this.setState({ [name]: val });


        if (name === 'txtEventStartTime') {
            this.HandleDateTime();
        }

    }

    HandleDateTime = () => {
        let finaldatetime = '';
        let timeoptions = {
            lang: 'EN', // default 'EN'
            format: 'HH:mm:ss', // default 'HH:mm'
            // default: '12:27', // default `new Date()`. If `default` type is string, then it will be parsed to `Date` instance by `format` . Or it can be a `Date` instance
            minuteStep: 5, // default 5. Select minutes step, must be one of [1, 5, 10]
            min: '00:00:00', // min time value, `{String | Date}`, default `new Date(1900, 0, 1, 0, 0, 0, 0)`
            max: '23:59:59' // max time value, `{String | Date}`, default `new Date(2100, 11, 31, 23, 59, 59, 999)`
        }
        let config = {
            // day: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            // shortDay: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
            // MDW: 'D, MM-d',
            // YM: 'yyyy-M',
            OK: 'OK',
            CANCEL: 'CANCEL',
            CLEAR: 'CLEAR'
        }
        var DateTimePicker = require('date-time-picker')
        let that = this;
        var timePicker = new DateTimePicker.Time(timeoptions, config)
        timePicker.on('selected', function (formatTime, now) {
            // formatTime = 18:30
            // now = Date instance -> Wed Oct 19 2016 18:30:13 GMT+0800 (CST)
            finaldatetime = finaldatetime + '  ' + formatTime;
            that.editDataObj['txtEventStartTime'] = finaldatetime;
            that.setState({ txtEventStartTime: finaldatetime })
        })
        timePicker.on('cleared', function () {
            // clicked clear btn
            finaldatetime = finaldatetime;
            that.editDataObj['txtEventStartTime'] = finaldatetime;
            that.setState({ txtEventStartTime: finaldatetime })
        })



        let options = {
            lang: 'EN', // default 'EN'. One of 'EN', 'zh-CN'
            format: 'yyyy-MM-dd', // default 'yyyy-MM-dd'
            // default: '2016-10-19', // default `new Date()`. If `default` type is string, then it will be parsed to `Date` instance by `format` . Or it can be a `Date` instance
            min: '2017-01-01', // min date value, `{String | Date}`, default `new Date(1900, 0, 1, 0, 0, 0, 0)`
            // max: '2018-11-08' // max date value, `{String | Date}`, default `new Date(2100, 11, 31, 23, 59, 59, 999)`
        }

        var datePicker = new DateTimePicker.Date(options, config)
        datePicker.on('selected', function (formatDate, now) {
            // formatData = 2016-10-19
            // now = Date instance -> Wed Oct 19 2016 20:28:12 GMT+0800 (CST)
            finaldatetime = finaldatetime + formatDate;
        })
        datePicker.on('cleared', function () {
            // clicked clear btn
            finaldatetime = finaldatetime;
        })
    }

    HandleEventImage = (e) => {


        this.editDataObj[e.target.name] = e.target.value;

    }
    HideModal = () => {
      //    alert('close')
        this.props.componentprops.currentAction.close();
    }
    componentDidMount = () => {
        this.ChangePageMode()
    }

    ShowError = (errormessage) => {

        document.getElementById('spnWarningMessageTitle').innerText = "Validation Response - ";
        document.getElementById('spnWarningMessage').innerText = errormessage
       // let that = this;
        $('#crmWarningAlert').slideDown().slideUp(3000, function () {
            // AppUtils.HandlePageClick(that.props.componentprops, 'leads');
        })

    }



    ChangePageMode = () => {
        let obj;
        // alert(JSON.stringify(this.props.componentprops.closeModal))
        // console.log(JSON.stringify(this.props.componentprops))

        if (this.props.componentprops.currentAction !== undefined && this.props.componentprops.currentAction.action === 'Detail') {
            // alert(JSON.stringify(this.props.componentprops.currentAction.data[0].event_category))
            this.setState({
                showEditBtn: 'flex',
                mode: 'edit',
                renderChild: true,
                currentSeletedEventId: this.props.componentprops.currentAction.data[0]._id,
                txtEventStartTime: this.props.componentprops.currentAction.data[0].event_start_time
            })



            this.editDataObj = {
                txtEventName: this.props.componentprops.currentAction.data[0].event_name,
                ddlEventCategory: this.props.componentprops.currentAction.data[0].event_category,
                ddlEventLanguage: this.props.componentprops.currentAction.data[0].event_language,
                ddlEventStatus: this.props.componentprops.currentAction.data[0].event_status,
                txtEventStartTime: this.props.componentprops.currentAction.data[0].event_start_time,
                txtEventDuration: this.props.componentprops.currentAction.data[0].event_duration,
                txtEventSeats: this.props.componentprops.currentAction.data[0].event_total_seats,
                txtEventAlreadyFilled: this.props.componentprops.currentAction.data[0].event_already_filled_seats,
                ddlEventMode: this.props.componentprops.currentAction.data[0].event_mode,
                ddlEventRecurring: this.props.componentprops.currentAction.data[0].event_recurring,
                ddlEventEntryMode: this.props.componentprops.currentAction.data[0].event_entry_mode,
                txtEventDescription: this.props.componentprops.currentAction.data[0].event_desc,
                ddlEventOrganizerName: this.props.componentprops.currentAction.data[0].organizer_details[0]._id,
                // ddlEventOrganizer: this.props.componentprops.currentAction.data[0].organizer_details[0].organizer_name,
                fileEventImage: this.props.componentprops.currentAction.data[0].event_image,
            }

            this.setState({
                ddlEventOrganizerName: this.props.componentprops.currentAction.data[0].organizer_details[0]._id,
                ddlEventLanguage: this.props.componentprops.currentAction.data[0].event_language,
                ddlEventCategory: this.props.componentprops.currentAction.data[0].event_category,
                ddlEventStatus: this.props.componentprops.currentAction.data[0].event_status,
            })

            obj = {
                eventActionHeading: 'Event Detail',
                editDeleteDiv: true,
                getEventData: true,
                currentSeletedEventId: this.props.componentprops.currentAction.data[0]._id,
                showButtonType: 'Update Session',
                formModeActivity: true,
                btnOrganizerOuterDiv: false,

            };
            let form = document.getElementById("frmEventEntry");
            let elements = form.elements;

            for (let i = 0, len = elements.length; i < len; ++i) {
                if (elements[i].id !== '')
                    elements[i].disabled = true;
            }

        }
        else {
            obj = { formModeActivity: false, btnOrganizerOuterDiv: true, editDeleteDiv: false };
            let form = document.getElementById("frmEventEntry");
            let elements = form.elements;
            for (let i = 0, len = elements.length; i < len; ++i) {
                elements[i].disabled = false;
            }
            this.editDataObj = {
                txtEventSeats: 100,
                txtEventAlreadyFilled: 10
            }
        }

        this.setState(obj);
    }

    ShowEditMode = () => {

        let form = document.getElementById("frmEventEntry");
        let elements = form.elements;
        for (let i = 0, len = elements.length; i < len; ++i) {
            if (elements[i].id !== "txtEventStartTime" && elements[i].id !== "ddlEventMode") {

                elements[i].disabled = false;
                // elements[2].disabled = false;
            }



        }

        this.setState({ formModeActivity: false, organizerActionHeading: 'Edit Event', btnUserProfileOuterDiv: true, showEditBtn: 'none', actionType: 'update' })

    }

    DuplicateMode = () => {
        this.setState({
            showEditBtn: 'none',
            actionType: 'save'
        })

        this.SaveEventEntryData();
    }



    SaveEventEntryData = (e) => {
        // alert(e.txtEventAlreadyFilled)


        // alert('iiii')
        // alert(this.state.txtEventName)

        if (e.txtEventStartTime === '') {
            this.ShowError('Invalid Start Time')
            return false;
        }

        let curr_date = new Date(Date.now())
        let event_date = new Date(e.txtEventStartTime)

        let diff = (event_date.getTime() - curr_date.getTime()) / 1000;
        diff /= 60;
        let diff2 = Math.round(diff);

        //   alert(diff2)

        if (diff2 <= 30) {
            this.ShowError('Start time should be 30 mins later from now')
            return false;
        }


        if (e.txtEventSeats / 2 <= e.txtEventAlreadyFilled) {
            this.ShowError('Filled seats should be less than half of the total seats')
            return false
        }

        // alert(this.state.txtEventName)
        //  alert(this.state.fileEventImage)
        // alert(e.ddlEventOrganizerName)
        //  this.setState({
        //      fileEventImage:e.fileEventImage
        //   })
        this.data = {

            txtEventName: e.txtEventName,
            txtEventStartTime: e.txtEventStartTime,
            ddlEventCategory: e.ddlEventCategory,
            ddlEventLanguage: e.ddlEventLanguage,
            ddlEventOrganizerName: e.ddlEventOrganizerName,
            ddlEventEntryMode: e.ddlEventEntryMode,
            ddlEventStatus: e.ddlEventStatus,
            txtEventSeats: e.txtEventSeats,
            txtEventAlreadyFilled: e.txtEventAlreadyFilled,
            txtEventDescription: e.txtEventDescription,
            txtEventPricingINR: e.txtEventPricingINR,
            txtEventPricingUSD: e.txtEventPricingUSD,
            txtEventDuration: e.txtEventDuration,
            ddlEventMode: e.ddlEventMode,
            ddlEventRecurring: e.ddlEventRecurring,

            fileEventImage: e.fileEventImage,


            // txtLeadSourceName: e.txtSourceName,
            // txtMailForwardTo: 'hello@neoroots.design',
            // txtDefaultAssignee: 'hello@neoroots.design',
            // ddlLeadSourceStatus: e.ddlSourceStatus,
            // imgLeadSourceImage: e.fileAdditionalAttachment,
        }
        //  this.PushNotification();
        if (this.state.actionType === 'save') {

            this.setState({
                sendData: true
            })
        }
        else {
            this.setState({
                editData: true, sendData: false
            })
        }


        // console.log(this.data);
    }

    HandleRouting = (route) => {
        AppUtils.HandlePageClick(this.props.componentprops, route)
    }

    HandleGetOrganizersListSuccessResponse = (res) => {
        if (res !== false) {
            //   console.log(JSON.stringify(res.data.organizerslist.rows))
            this.setState({
                organizerlist: res.data.organizerslist.rows,
                getOrganizers: false

            })


        }

        else {
            this.setState({
                getOrganizers: false
            })

        }
    }

    HandleGetCategoryListSuccessResponse = (res) => {
        if (res !== false) {
            //   console.log(JSON.stringify(res.data))
            this.setState({
                categorylist: res.data.categorieslist.rows,
                getCategory: false

            })


        }

        else {
            this.setState({
                getCategory: false
            })

        }
    }


    AddEventGoogleCalendar = () => {

        //   alert(JSON.stringify(this.data))

        gapi.load('client:auth2', () => {
            // console.log('loaded client');
            gapi.client.init({
                apiKey: apiKey,
                clientId: clientID,
                discoveryDocs: discovery_docs,
                scope: scopes
            })
            gapi.client.load('calendar', 'v3', () => {
                console.log('bam!');
            })
            gapi.auth2.getAuthInstance().signIn()
                .then(() => {
                    var start_time = new Date(this.data.txtEventStartTime)
                    var end_time = new Date(this.data.txtEventStartTime)
                    var endtime = end_time.getTime();
                    var duration = this.data.txtEventDuration * 60000;
                    var final_end_time = new Date(endtime + duration);
                    final_end_time.toISOString();
                    //   alert(final_end_time);
                    start_time.toISOString();
                    //  alert(start_time);
                    // var end_time = new Date(this.data.txtEventStartTime.getTime() + this.data.txtEventDuration*60000);
                    //var end_time = new Date(this.state.txtEventEndTime)
                    //  alert(end_time)
                    // end_time.toISOString();
                    //  alert(' end time' +end_time)
                    var event = {
                        'summary': this.data.txtEventName,
                        // 'location': this.data.ddlEventMode,
                        'description': this.data.txtEventDescription,
                        'start': {
                            'dateTime': start_time,
                            'timeZone': 'GMT+05:30'
                        },
                        'end': {
                            'dateTime': final_end_time,
                            'timeZone': 'GMT+05:30'
                        },
                        // 'recurrence': [
                        //   'RRULE:FREQ=DAILY;COUNT=2'
                        // ],
                        // 'attendees': [
                        //     { 'email': 'ausafsjc97@gmail.com' },
                        //     { 'email': 'sbrin@example.com' }
                        // ],
                        'reminders': {
                            'useDefault': false,
                            'overrides': [
                                { 'method': 'email', 'minutes': 24 * 60 },
                                { 'method': 'popup', 'minutes': 10 }
                            ]
                        }
                    };
                    var request = gapi.client.calendar.events.insert({
                        'calendarId': 'primary',
                        'resource': event
                    });

                    request.execute(event => {
                        window.open(event.htmlLink);
                    });
                })
        })


    }

    PushNotification = (id) => {

        let organizerId;
        //  alert(this.state.fileEventImage);
        this.state.organizerlist.map((items, i) => {
            if (items._id === this.state.ddlEventOrganizerName) {
                organizerId = i;
            }
        })
        //  alert(organizerId);
        var data = JSON.stringify({
            "app_id": "b73b1d9d-2e6e-43fe-81e1-b9ab31caba87",
            "included_segments": [
                "Subscribed Users"
            ],
            //  "include_external_user_ids":["123456789"],
            "data": {
                "foo": "bar"
            },
            "name": "Session",
            "contents": {
                "en": `Hello user please check out this new session ${this.state.txtEventName} organized by ${this.state.organizerlist[organizerId].organizer_name}`
            },
            "web_push_topic": `${id}`,
            "url": `https://www.kinshipliving.com/session-details/${id}`,
            "chrome_web_icon": `${img_path + this.state.fileEventImage.replace(',', '')}`

        });

        var config = {
            method: 'post',
            url: 'https://onesignal.com/api/v1/notifications',
            headers: {
                'Authorization': 'Basic YWJmOTYyNDktODE0NC00Y2FjLWE2NTItODQxZmVhNThhNGNl',
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(config)
            .then(function (response) {
                console.log(JSON.stringify(response.data));
            })
            .catch(function (error) {
                console.log(error);
            });


    }

   
    HandleUpdateEventDataSuccessResponse = (res) => {
     

        if (res !== false) {
            // this.props.componentprops.currentAction.organizerListUpdate = true
            this.setState({
                editData: false,
            })
            this.HideModal();
            // this.props.componentprops.handleClose();

        }
        else {
            this.setState({
                editData: false
            })
        }
    }

    closeSuccesModal = () => {
        this.setState({
            isModalOpen: false
        })
    }

    HandleCreateEventSuccessResponse = (res) => {
        if (res !== false) {
            //   console.log(JSON.stringify(res));
            let id = res.data.addeventresponse.message.value
            let _id = id.slice(id.indexOf('-') + 1, id.length);

          

         
            document.getElementById('spnSuccessMessageTitle').innerText = "Server Response";
            // document.getElementById('spnSuccessMessage').innerText = res.data.userloginresponse.message.value;
            document.getElementById('spnSuccessMessage').innerText = 'Event Created Successfully';
            let that = this;
            $('#crmSuccessAlert').slideDown().slideUp(3000, function () {
               
                that.HideModal();
            })

            this.setState({
                createEvent: false,
               
            })
             

             this.AddEventGoogleCalendar();
            this.PushNotification(_id);
        

         



            // this.props.componentprops.currentAction.close();
        }

        else {

            document.getElementById('spnWarningMessageTitle').innerText = "Server Response";
            document.getElementById('spnWarningMessage').innerText = "Event Creation Failed"
          //  let that = this;
            $('#crmWarningAlert').slideDown().slideUp(3000, function () {
                //  that.HideModal();
                // AppUtils.HandlePageClick(that.props.componentprops, 'leads');
            })
            this.setState({
                createEvent: false
            })
        }
    }



    render() {
        return (
            <div>


                <EventForm {...this.props} HandleRouting={this.HandleRouting}
                    HandleEventInput={this.HandleEventInput} editDataObj={this.editDataObj}
                    mystate={this.state} txtEventName={this.state.txtEventName} HandleEventImage={this.HandleEventImage}
                    SaveEventEntryData={this.SaveEventEntryData} organizerlist={this.state.organizerlist}
                    ShowEditMode={this.ShowEditMode} categorylist={this.state.categorylist} DuplicateMode={this.DuplicateMode}
                />

                {((this.state.getOrganizers === true) ? GetOrganizersList(this.props.PnkStore, this.HandleGetOrganizersListSuccessResponse) : "")}
              
                {((this.state.getCategory === true) ? GetCategoryData(this.props.PnkStore, this.HandleGetCategoryListSuccessResponse) : "")}
                {(this.state.editData === true) ? UpdateEventDetails(this.props.PnkStore, this.state.currentSeletedEventId, this.data, this.HandleUpdateEventDataSuccessResponse) : ""}
                {((this.state.sendData === true) ? CreateEvents(this.props.PnkStore, this.data, this.HandleCreateEventSuccessResponse) : "")}
            </div>
        )
    }
}

export const CreateEvent = PnkConnect(createEvent, '');